import { EditOutlined } from "@ant-design/icons";
import { Badge, Button, Modal, Space, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import dayjs from "dayjs";
import _ from "lodash";
import { useEffect, useState } from "react";
import { ContentPartHistoryReservoir } from "../../../components/content-part/ContentPartHistoryReservoir";
import { PageHeader } from "../../../components/page-header";
import { EntReservoirFilter } from "../../../models/filters/reservoirFilter";
import { EntReservoirHistoryFilter } from "../../../models/filters/reservoirHistoryFilter";
import { EntReservoirGroupByHistory } from "../../../models/reservoirGroupByHistory";
import { useGetReservoirListQuery } from "../../../redux/api/reservoir/reservoirApi";
import { AddReservoirHistoryModal } from "./AddReservoirHistoryModal";
import { FilterReservoirsHistory } from "./FilterReservoirsHistory";
import { useReservoirsHistory } from "./useReservoirsHistory";
import { ReportReservoirHistoryModal } from "./ReportReservoirHistoryModal";
import { EntReportReservoirHistory } from "../../../models/utils/reportReservoirHistory";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetReservoirHistoryGroupByListQuery } from "../../../redux/api/reservoirHistory/reservoirHistoryApi";

enum FormField {
  reservoirId,
  dateForDayFrom,
  dateForDayTo,
  deleted
}

export const ReservoirsHistory = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedReservoirHistory, setSelectedReservoirHistory] = useState<EntReservoirGroupByHistory>(new EntReservoirGroupByHistory());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const { data: reservoirs } = useGetReservoirListQuery(new EntReservoirFilter());
  const [dateFrom, setDateFrom] = useState(dayjs().subtract(11, "day"));
  const [dateTo, setDateTo] = useState(dayjs().subtract(1, "day"));
  const { t } = useTranslation()
  const [form] = useForm();

  const [getArchiveFolders] = useLazyGetReservoirHistoryGroupByListQuery();
  const {
	filter,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntReservoirGroupByHistory, EntReservoirHistoryFilter>({
	initialFilter: new EntReservoirHistoryFilter({
	  dateForDayFrom: dateFrom.format('YYYY-MM-DD'),
	  dateForDayTo: dateTo.format('YYYY-MM-DD')
	}),
	query: getArchiveFolders
  });

  const {
	onAddReservoirHistory,
	onEditReservoirHistory,
	onGenerateReservoirReport
  } = useReservoirsHistory(modal, () => {
	searchHandleClick();
  })
  const openAddModal = (item: EntReservoirGroupByHistory) => {
	setSelectedReservoirHistory(item);
	setShowModal(true);
  }
  const openReportModal = (entReportReservoirHistory: EntReportReservoirHistory) => {
	setShowReportModal(true);
  };


  const handleSubtract10Days = () => {
	const newDateFrom = dateFrom.subtract(10, "day");
	const newDateTo = dateTo.subtract(10, "day");
	setDateFrom(newDateFrom);
	setDateTo(newDateTo);
	form.setFields([
	  { name: FormField.dateForDayFrom, value: newDateFrom },
	  { name: FormField.dateForDayTo, value: newDateTo },
	]);
	searchHandleClick()
  };
  const handleAdd10Days = () => {
	const newDateFrom = dateFrom.add(10, "day");
	const newDateTo = dateTo.add(10, "day");
	setDateFrom(newDateFrom);
	setDateTo(newDateTo);
	form.setFields([
	  { name: FormField.dateForDayFrom, value: newDateFrom },
	  { name: FormField.dateForDayTo, value: newDateTo },
	]);
	searchHandleClick()
  };


  const setFieldsFromEntity = (): void => {
	form.setFields([
	  { name: FormField.dateForDayFrom, value: dateFrom },
	  { name: FormField.dateForDayTo, value: dateTo },
	]);
  };

  useEffect(() => {
	setFieldsFromEntity();
	searchHandleClick()
  }, [reservoirs])


  const setEntityFromFields = (): EntReservoirHistoryFilter => {
	let filt: EntReservoirHistoryFilter = _.clone(filter);
	filt.dateForDayTo = form.getFieldValue(FormField.dateForDayTo) ?? null;
	filt.dateForDayFrom = form.getFieldValue(FormField.dateForDayFrom) ?? null;
	filt.page = 1;
	return filt;
  }
  const clearFields = () => {
	form.setFields([
	  { name: FormField.dateForDayFrom, value: null },
	  { name: FormField.dateForDayTo, value: null },
	]);
  }
  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }
  const table = (
	<div onScroll={ scrollHandler }>

	  <div className="tableRservmain">

		<div className="fixed_col_head">
		  <div style={ { minWidth: 230, backgroundColor: '#99B636', zIndex: 9, display: "block", padding: '10px 8px' } }
			   className="fixed_col ">Водохранилища и данные
		  </div>
		  { access && access.methodPut && (
			data.map((item, index) => (
			  <div className="fixed_col_head_item" key={ item.dateForDay }
				   style={ { minWidth: 140, display: "block" } }>
				<Button
				  onClick={ () => {
					openAddModal(item);
				  } }
				  type="primary">
				  { item?.dateForDay } <EditOutlined/>
				</Button>
			  </div>
			))
		  ) }
		</div>

		<div>
		  <div style={ { display: "flex" } }>

			<div className="fixed_col" style={ { minWidth: 230 } }>
			  <div className="resColumn">
				{ reservoirs &&
				  reservoirs.res?.content.map((element) => (

					<div className="tableRserv" key={ element.id }>
					  <p>{ element?.nameKy }</p>
					  <ul>
						<li>{ t('reservoir_history.admission') } </li>
						<li>{ t('reservoir_history.work_off') }</li>
						<li>{ t('reservoir_history.volume') }</li>
					  </ul>
					</div>
				  )) }
			  </div>
			</div>


			{ data.map((item, index) => (
			  <div style={ { minWidth: 140 } } key={ `original-${ item.dateForDay }` }>
				<div className="resColumn">
				  { item.reservoirs !== null && typeof item.reservoirs === 'object' ? (
					Object.values(item.reservoirs).map((element, idx) => (
					  element !== null ? (
						<div className="tableRserv" key={ idx }>

						  <ul>
							<li>{ element.reservoir?.nameRu }</li>
							<li>{ element.admission }</li>
							<li>{ element.workOff }</li>
							<li>{ element.volume }</li>
						  </ul>
						</div>
					  ) : (
						<div className="tableRserv" key={ idx }>
						  <ul>
							<li>{ t('general.no_data') }</li>
						  </ul>
						</div>
					  )
					))
				  ) : (
					""
				  ) }
				</div>
			  </div>
			)) }


		  </div>
		</div>
	  </div>
	</div>
  );

  const highlightedDates = data.map((item) => dayjs(item.dateForDay));
  const dateCellRender = (value: dayjs.Dayjs) => {
	const isHighlighted = highlightedDates.some((date) =>
	  date.isSame(value, "day")
	);
	if (isHighlighted) {
	  return <Badge color="green" text="Данные"/>;
	}
	return null;
  };

  return (
	<>
	  <PageHeader
		title={ t('titles.register_of_hostory_reservoirs') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ `Записей найдено: ${ totalItems }` }</Typography.Text>
		}/>
	  {/* <Calendar
        dateCellRender={dateCellRender}
      /> */ }
	  <ContentPartHistoryReservoir
		filter={ <FilterReservoirsHistory openAddModal={ () => {
		  openAddModal(new EntReservoirGroupByHistory)
		} } openReportModal={ () => openReportModal(new EntReportReservoirHistory()) } onReset={ () => {
		  clearFields();
		  searchHandleClick()
		} } onSearch={ searchHandleClick } formField={ FormField } form={ form } access={ access }/> }
		table={ table }
	  />
	  <div style={ { display: "flex", justifyContent: "end" } }>
		<Space.Compact>
		  <Button onClick={ handleSubtract10Days }>{ t('reservoir_history.day_data_min') }</Button>
		  <Button onClick={ handleAdd10Days }>{ t('reservoir_history.day_data_max') }</Button>
		</Space.Compact>
	  </div>
	  <AddReservoirHistoryModal
		reservoirHistory={ selectedReservoirHistory }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedReservoirHistory.id !== null ? onEditReservoirHistory : onAddReservoirHistory }
	  />
	  <ReportReservoirHistoryModal
		reservoirHistory={ selectedReservoirHistory }
		show={ showReportModal }
		onHide={ () => {
		  setShowReportModal(false)
		} }
		onSubmit={ onGenerateReservoirReport }
	  />
	  { contextHolder }
	</>
  )
}
